import { Card, Box, styled, Stack } from "@mui/material";
import AutocompleteDropdown from "./common/auto-complete";

// STYLED COMPONENTS
const CardRoot = styled(Card)({
  height: "100%",
  padding: "20px 24px"
});

const CardTitle = styled("div")(({ subtitle }) => ({
  fontSize: "1rem",
  fontWeight: "500",
  textTransform: "capitalize",
  marginBottom: !subtitle && "16px"
}));

const CardTitleWrapper = styled(Stack)(() => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px"
}));

export default function SimpleCard(props) {
  const {
    children,
    title,
    subtitle,
    handleChangeStatus,
    options,
    value,
    isFilter,
    isDefaultOptions
  } = props;
  return (
    <CardRoot elevation={6}>
      {(title || isFilter) && (
        <CardTitleWrapper>
          <CardTitle subtitle={subtitle}>{title}</CardTitle>
          {isFilter && (
            <AutocompleteDropdown
              handleChange={handleChangeStatus}
              options={options}
              value={value}
              isDefaultOptions={isDefaultOptions}
            />
          )}
        </CardTitleWrapper>
      )}
      {subtitle && <Box mb={2}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
}
